module.exports = __webpack_public_path__ + "static/media/notifi_close.2cc22eaf.svg";